import { toast as notify } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: "top-right",
  theme: "light",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
};

const toastMap = {
  success: notify.success,
  error: notify.error,
  info: notify.info,
  warning: notify.warning,
};

// 🔒 Global lock
let isToastActive = false;

/**
 * Global toast with single-instance enforcement
 * @param {string} type - success | error | info | warning
 * @param {string} text - message to display
 * @param {number} [timeout=3000] - lock duration
 */
export const toast = (type, text, timeout = 3000) => {
  if (isToastActive) return;

  isToastActive = true;
  const showToast = toastMap[type] || notify;
  showToast(text, toastOptions);

  setTimeout(() => {
    isToastActive = false;
  }, 3000);
};
